import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import HolidayList from 'components/Lists/HolidayList'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { Container } from '../../styles'

export default function EditHolidays () {
  const [loading, setLoading] = useState (true)
  const [holidays, setHolidays] = useState ([])
  const businessId = AuthService.getBusinessId ()
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getData ()
  }, [])

  const getData = async () => {
    try {
      setLoading (true)

      const { data: holidays } = await cutileiApi.get (
        `/businesses/${businessId}/holidays`,
        requestConfig
      )

      setHolidays (holidays)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  const handleEditHoliday = holiday => {
    setHolidays (prev => prev.map (h => h.id === holiday.id ? {...holiday} : h))
  }

  if (loading) return <Loading style={{marginTop: 30}}/>

  return (
    <Container style={{paddingTop: 10}}>
      <HolidayList holidays={holidays} onEdit={handleEditHoliday}/>
    </Container>
  )
}
